module.exports = __webpack_public_path__ + "static/img/person.ce3dd3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/imags/person.png
// module id = p8xL
// module chunks = 35